import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';
import { SupplierRegisterPublicRequest } from '@/main/models/request';

export abstract class IRegistrationPublicApi {
  abstract confirmationcode(
    userEmail: string
  ): Promise<AxiosResponse<Result<string>>>;
  abstract registerBodyshopPublic(
    request: SupplierRegisterPublicRequest
  ): Promise<AxiosResponse<Result<string>>>;
  abstract registerSupplierPublic(
    request: SupplierRegisterPublicRequest
  ): Promise<AxiosResponse<Result<string>>>;
}

